export default __webpack_public_path__ + "static/media/bean-type-mobile.29f6c331.webp";